import { render, staticRenderFns } from "./MatchTeam.vue?vue&type=template&id=3a351cba&scoped=true&"
import script from "./MatchTeam.vue?vue&type=script&lang=js&"
export * from "./MatchTeam.vue?vue&type=script&lang=js&"
import style0 from "./MatchTeam.vue?vue&type=style&index=0&id=3a351cba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a351cba",
  null
  
)

export default component.exports